import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

import { AuthPayload, AuthResponse, UserMeResponse } from './auth.model';

@Injectable({ providedIn: 'root' })
export class AuthRepository {
  private readonly authPathSegment = '/authn';
  private readonly loginPath = `${this.authPathSegment}/login/`;
  private readonly logoutPath = `${this.authPathSegment}/logout/`;

  constructor(private httpClient: HttpClient) {}

  login(payload: AuthPayload): Observable<AuthResponse> {
    return this.httpClient
      .post<AuthResponse>(`${environment.apiUrl}${this.loginPath}`, payload)
      .pipe(catchError((err) => throwError(() => err)));
  }

  logout(): Observable<void> {
    return this.httpClient
      .post<void>(`${environment.apiUrl}${this.logoutPath}`, {})
      .pipe(catchError((err) => throwError(() => err)));
  }

  userMe(): Observable<UserMeResponse> {
    return this.httpClient
      .get<UserMeResponse>(`${environment.apiUrl}/users/me`)
      .pipe(catchError((err) => throwError(() => err)));
  }
}
